"use client";
import React from "react";
import { faqData } from "../../constants/data";
import InfoSection from "../common/InfoSection";
import FAQ from "../common/FAQ";
import frame1 from "../../assets/iso_Frame.svg";
import frame2 from "../../assets/logo-fips-140-2 1.svg";
import exportLogo from "../../assets/export.svg";
import navigateIcon from "../../assets/navigetIcon.svg";

function SecurityPolicy() {
  return (
    <div className="max-w-1200 mx-auto w-full">
      <div className="px-6 lg:px-0 sm:py-8">
          <div className="flex flex-col gap-14">
            <InfoSection
              title="SECURITY"
              subtitle="Security and Privacy"
              description="security is our top priority. We implement advanced encryption, multi-layered protection, and strict data privacy protocols to ensure your sensitive information is safeguarded at every step. Our secure platform guarantees the confidentiality and integrity of your information, giving you peace of mind as you automate compliance."
              additionalText=""
              buttonText="Read More"
              icon={exportLogo}
              descriptionhead="At RegTechFlow,"
              imageArray={[frame1, frame2]}
              width="max-w-4xl"
              gap="2rem"
              descriptionHidden={true}
              path="/security"
              hoverICon={navigateIcon}
              smallContainer={true}
            />
            <div>
              <FAQ faqs={faqData} />
            </div>
          </div>
      </div>
    </div>
  );
}

export default SecurityPolicy;
